import * as React from 'react';
import {CURRENT_CHECKED, CHECKED, DISABLED} from '../../constants/StepConstants';
import AssetsManager from '../../../common/utils/AssetsManager';
import {StepsProps} from '../../types/mx/creditoReal/components';
import Badge from '../../../common/components/Badge';

class StepView extends React.Component<StepsProps, {}> {

    static defaultProps = {
        steps: []
    };

    constructor(props) {
        super(props);
    }

    setStepStyles = (stepState) => {
        switch (stepState) {
            case CURRENT_CHECKED:
                return 'current-checked';
            case CHECKED:
                return 'checked';
            case DISABLED:
                return 'disabled';
            default:
                return 'disabled';
        }
    }

    render() {
        const {
            steps, stepNameSelected, stepPercentageSelected, stepIdSelected, onPressBackStep, mainStep,
            bureauAlreadyValidated
        } = this.props;
        const currentStepId = parseInt(stepIdSelected, 10);
        const prevStepId = currentStepId > 0 ?
            currentStepId === 3 ? currentStepId - 2 : currentStepId - 1 : currentStepId;

        return (
            <div className="steps">
                <div className="d-none d-sm-none d-md-block">
                    <ul className="list-group steps-list">
                        {mainStep && mainStep.filter(item => item.visible).map(mItem =>
                            <Badge badgeStyle={`badge badge-pill badge-bordered md ${
                                this.setStepStyles(mItem.selected)}`} key={mItem.id}
                                   lineBadgeStyle={`badge-step-line ${this.setStepStyles(mItem.selected)}`}
                                   currentStep={(parseInt(mItem.id, 10) + 1).toString()}
                                   label={mItem.name} labelStyle={`wizard-steps badge-item ${
                                this.setStepStyles(mItem.selected)}`}>
                                <ul className="list-group steps-list ml-5 step-group-left">
                                    {steps.filter(item => item.visible && item.parentId === mItem.id).map(item =>
                                        <li key={item.id} id={item.id}
                                            onClick={item.selected !== DISABLED && !bureauAlreadyValidated ?
                                                item.onPress : () => {}
                                            }
                                            className={`list-group-item ${this.setStepStyles(item.selected)}`}>
                                            {item.selected === CHECKED ? <div className="bullet-check">
                                                <img src={
                                                    AssetsManager(
                                                        '/assets/images/common/bullet-check.svg'
                                                    )
                                                } alt="Regresar"/>
                                            </div> : null}
                                            {item.name}
                                        </li>
                                    )}
                                </ul>
                            </Badge>)

                        }
                    </ul>
                </div>
                <div className="d-block d-sm-none d-sm-block d-md-none mb-4">
                    <div className="d-flex align-items-center steps-item">
                        <div className="step-back d-flex justify-content-start">
                            {currentStepId > 0 && !bureauAlreadyValidated ?
                                <img src={AssetsManager('/assets/images/common/back-icon.svg')} alt="Regresar"
                                     onClick={e => onPressBackStep(prevStepId.toString())}/> : ''}
                        </div>
                        <div className="step-name d-flex align-items-center justify-content-center">
                            {stepNameSelected}</div>
                    </div>
                    <div className="progress">
                        <div className={`progress-bar width-${stepPercentageSelected}`} role="progressbar"/>
                    </div>
                </div>
            </div>
        );
    }
}

export default StepView;
